export interface FetchClientHttpError extends Error {
  status: number;
  /** RFC 9457 problem `type` URI, when the API sends one. */
  type?: string;
  /** Seconds to wait before retrying, from a 429's `Retry-After` header. */
  retryAfterSeconds?: number;
}

export function createFetchClientHttpError(
  message: string,
  status: number,
  type?: string,
  retryAfterSeconds?: number,
): FetchClientHttpError {
  const error = new Error(message) as FetchClientHttpError;
  error.status = status;
  error.type = type;
  error.retryAfterSeconds = retryAfterSeconds;
  return error;
}
